module.exports = __webpack_public_path__ + "static/media/banner-clients-01.9b2386d2.jpg";